import { Box, Checkbox, FormControlLabel } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import { REPORTING_ACCOUNT_TYPE_LABELS } from "../../constants"
import type { ChartOfAccountsSearchParams } from "../../types/searchParams"

import { ReportingAccountType } from "@/graphql/codegen/graphql"

const reportingAccountTypeList = Object.values(ReportingAccountType)

interface ReportingAccountTypeFilterProps {
  onFilterChange: (name: keyof ChartOfAccountsSearchParams, value: unknown) => void
}

export const ReportingAccountTypeFilter: FC<ReportingAccountTypeFilterProps> = ({ onFilterChange }) => {
  const { watch, setValue } = useFormContext()
  const reportingAccountTypeValue = watch("reportingAccountType")

  const handleCheckboxChange = (value: ReportingAccountType) => {
    // Radio button behavior: if clicking the same one, uncheck it; otherwise select the new one
    const newValue = reportingAccountTypeValue === value ? undefined : value
    setValue("reportingAccountType", newValue)
    onFilterChange("reportingAccountType", newValue)
  }

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {reportingAccountTypeList.map((reportingAccountType) => (
        <FormControlLabel
          key={reportingAccountType}
          control={
            <Checkbox
              checked={reportingAccountTypeValue === reportingAccountType}
              onChange={() => handleCheckboxChange(reportingAccountType)}
            />
          }
          label={REPORTING_ACCOUNT_TYPE_LABELS[reportingAccountType]}
          className='w-full text-ellipsis'
        />
      ))}
    </Box>
  )
}
